import {reactive} from "vue";
import {withState} from "../../helpers/store-helper";

const state = reactive({
    portalTranslationSettings: {},
})

const setPortalTranslationSettings = (translationSettings) => {
    state.portalTranslationSettings = translationSettings
}

export default () => withState({
    setPortalTranslationSettings
}, state)
